import { PatientRepository } from "@/domain/repository/patient-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class ActivatePatientUsecase {
  //MARK:- Constructor
  constructor(private readonly patientRepo: PatientRepository) {}

  //MARK:- execute
  async execute(patientUuid: string): Promise<SATResult<void, SATError>> {
    const result = await this.patientRepo.activatePatient(patientUuid);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }
}
